/* eslint-disable max-len */
/* eslint-disable no-empty */
/* eslint-disable no-restricted-globals */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable radix */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState, useEffect, useCallback, useMemo,
} from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { makeStyles, styled } from '@material-ui/core/styles';
import {
  Box, Typography,
  IconButton,
  Stepper, Step, StepLabel, Container,
  Grid,
  Card,
  CardContent,
  FormControlLabel,
  Checkbox,
  FormControl,
  useTheme,
  Link,
  Input,
  StepConnector,
  Tooltip,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/EditOutlined';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowBack from '@material-ui/icons//ArrowBackIos';
import Switch from '@material-ui/core/Switch';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { Controller, useForm } from 'react-hook-form';
import PurchaseSummary from '../../components/marketPlace/PurchaseSummary';
import CustomDialog from '../../components/marketPlace/Modal';
import iconoProducto from '../../assets/img/marketPlace/IconoProducto.png';
import InfoIcon from '../../assets/img/marketPlace/InfoIcon.svg';
import { Rules } from '../../helpers/RHFRules';
import { RulesAndRegex } from '../../helpers/RHFRulesAndRegex';
import Warning from '../../components/marketPlace/Warning';
import {
  updateCartQuantityAction, removeCartItemAction, saveOrderAction,
  getCatalogAction, updateCartItemAction, cartAddAction, cartAddEmergencyAction,
  sendToePaycoPaymentMarketAction, getContractCustomerInfoAction,
  GetCountriesFlagsAction,
} from '../../actions/license.action';
import { getDocumentTypesAction, getParmeterConfigAction, getStateAndCitiesAction } from '../../actions/general.action';
import { calculateCheckDigit } from '../../helpers/generalUtils';
import { GET_CART_ERROR, SAVE_ORDER_MARKET_ERROR, SET_PROMO_FEEDBACK } from '../../types/license.type';
import CustomInput from '../../components/marketPlace/CustomInput';
import CustomSelect from '../../components/marketPlace/CustomSelect';
import { getBlackListEmailsAction } from '../../actions/email.action';
import CustomSelectAutocomplete from '../../components/marketPlace/CustomSelectAutocomplete';
import CustomAutocompleteImage from '../../components/marketPlace/CustomAutocompleteImage';

const useStyles = makeStyles((theme) => ({
  mainContent: {
    marginTop: theme.spacing(4),
    paddingBottom: theme.spacing(8),
  },
  stepper: {
    width: '60%',
    backgroundColor: 'transparent',
    padding: theme.spacing(3, 0, 5),
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width:605px)': {
      width: '100%',
      margin: 0,
    },
  },
  stepLabel: {
    '& .MuiStepLabel-label': {
      fontFamily: '"Raleway"',
      fontWeight: 500,
      color: theme.body.stepper.uncompleted,
    },
    '& .MuiStepLabel-active': {
      color: `${theme.body.stepper.active} !important`,
    },
    '& .MuiStepLabel-completed': {
      color: `${theme.body.stepper.completed} !important`,
    },
    '& .MuiStepIcon-root': {
      color: theme.body.stepper.iconRoot,
    },
    '& .MuiStepIcon-active': {
      color: theme.body.stepper.iconActive,
    },
    '& .MuiStepIcon-completed': {
      color: theme.body.stepper.iconCompleted,
    },
    '& .MuiStepIcon-text': {
      fontSize: '14px',
      fontFamily: '"Karla"',
      fontWeight: 600,
      fill: theme.body.stepper.iconText,
    },
    '& .MuiStepIcon-active .MuiStepIcon-text': {
      fontSize: '14px',
      fontFamily: '"Karla"',
      fontWeight: 600,
      fill: theme.body.stepper.iconActiveText,
    },
  },
  stepContainer: {
    backgroundColor: 'transparent',
    padding: theme.spacing(2, 0),
    boxShadow: 'none',
    minHeight: '400px',
  },
  productCard: {
    display: 'flex',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.body.cart.products.main}`,
    borderRadius: '16px',
    backgroundColor: theme.body.cart.products.main,
    transition: '0.3s',
    '@media (max-width:600px)': {
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    '&:hover': {
      boxShadow: `0px 8px 20px ${theme.body.cart.products.hover}`,
    },
  },
  priceBlock: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    minWidth: '220px',
    '@media (max-width:600px)': {
      alignItems: 'center',
      width: '100%',
      minHeight: 'auto',
      gap: theme.spacing(2),
      paddingTop: theme.spacing(2),
      borderTop: `1px solid ${theme.body.cart.products.secondary}`,
    },
  },
  radio: {
    color: theme.body.radio.color,
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  connectorActive: {
    '& .MuiStepConnector-line': {
      borderColor: theme.body.stepper.connectorActive,
    },
  },
  connectorCompleted: {
    '& .MuiStepConnector-line': {
      borderColor: theme.body.stepper.connectorCompleted,
    },
  },
  connectorDisabled: {
    '& .MuiStepConnector-line': {
      borderColor: theme.body.stepper.connectorDisabled,
    },
  },
  connectorLine: {
    borderTopWidth: 1,
  },
  fontform: {
    letterSpacing: 0,
    fontFamily: '"Raleway"',
  },
  customSelectFont: {
    fontFamily: "'Raleway'",
    '& .MuiSelect-select': {
      fontFamily: "'Raleway' !important",
    },
    '& .MuiInputLabel-root': {
      fontFamily: "'Raleway' !important",
    },
    '& *': {
      fontFamily: "'Raleway' !important",
    },
  },
  menuFont: {
    '& .MuiMenuItem-root': {
      fontFamily: "'Raleway'",
    },
  },
  styleInputs: {
    '& .MuiInputBase-root': {
      fontFamily: "'Karla'",
    },
    '& .MuiInputLabel-root': {
      fontFamily: "'Karla'",
    },
    '& .MuiTypography-root': {
      fontFamily: "'Karla'",
    },
  },
  switchBase: {
    color: theme.body.switchBase.color,
    '&$checked': {
      color: theme.palette.primary.main,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
      },
    },
    '&$disabled': {
      color: `${theme.body.switchBase.disabled.color} !important`,
      '& + $track': {
        backgroundColor: `${theme.body.switchBase.disabled.track.backgroundColor} !important`,
        opacity: 1,
      },
    },
  },
  checked: {},
  disabled: {},
  track: {
    backgroundColor: theme.body.switchBase.disabled.track.backgroundColor,
    opacity: 1,
  },
  myCustomTooltip: {
    backgroundColor: `${theme.body.form.location.backgroundColor} !important`,
    color: `${theme.body.form.location.color} !important`,
    padding: '10px',
    '& .MuiTooltip-arrow': {
      color: `${theme.body.form.location.arrow.color} !important`,
    },
  },
}));

const OwnTypography = styled(Typography)(({ theme }) => ({
  color: theme.header.badgeItems.color,
  fontWeight: 700,
  fontSize: 20,
  letterSpacing: 0,
  fontFamily: '"Karla"',
}));

const OwnTypographySubtotal = styled(Typography)(({ theme }) => ({
  color: theme.body.cart.products.text,
  display: 'block',
  fontSize: '24px',
}));

const OwnCard = styled(Card)(() => ({
  padding: 10,
  paddingBottom: 8,
  borderRadius: 16,
}));

const OwnCardTyC = styled(Card)(() => ({
  paddingLeft: 10,
  paddingRight: 10,
  borderRadius: 16,
}));

const getInputStyles = (theme) => ({
  marginRight: 10,
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.body.form2.backgcolor,
    borderRadius: '10px',
    height: '48px',
    '& fieldset': {
      borderColor: theme.body.form2.field,
    },
    '&:hover fieldset': {
      borderColor: theme.body.form2.borderr,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.body.form2.borderr,
    },
  },
  '& .MuiSelect-select.MuiSelect-select': {
    fontFamily: 'Raleway',
    fontSize: '14px',
    fontWeight: 400,
    height: '48px',
    padding: '0 14px',
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiInputLabel-outlined': {
    fontFamily: 'Raleway',
    fontSize: '14px',
    fontWeight: 400,
    transform: 'translate(14px, 14px) scale(1)',
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
  },
  '& .MuiSelect-icon': {
    top: 'calc(50% - 12px)',
  },
  letterSpacing: 0,
});

const OwnCustomSelect = styled(CustomSelect)(({ theme }) => (
  getInputStyles(theme)
));

const OwnCustomAutocompleteImage = styled(CustomAutocompleteImage)(({ theme }) => (
  getInputStyles(theme)
));

const OwnCustomSelectAutocomplete = styled(CustomSelectAutocomplete)(({ theme }) => (
  getInputStyles(theme)
));

const OwnCustomInput = styled(CustomInput)(({ theme }) => (
  getInputStyles(theme)
));

const OwnCheckbox = styled(Checkbox)(({ theme }) => ({
  color: theme.body.form2.textColor,
  '&.Mui-checked': {
    color: theme.palette.primary.main,
  },
}));

const steps = ['Tus productos', 'Facturación', 'Pago'];

const MarketPlace = (props) => {
  const {
    cartData,
    updateCartQuantity,
    removeCartItem,
    statesAndCities,
    getStatesAndCities,
    getDocumentTypes,
    documentTypes,
    getParmeterConfig,
    appName,
    parameterApp,
    tenant,
    saveOrder,
    licenseLoadingSaveOrder,
    getCatalog,
    getItemsCatalog,
    updateCartItem,
    loadingMarketPlace,
    code,
    cartAddEmergency,
    cartAdd,
    getParametersMarket,
    licenseSaveOrderSuccess,
    onReady,
    loadingViewMore,
    setLoadingViewMore,
    saveOrderSuccess,
    sendToePaycoPaymentMarket,
    saveOrderMarketError,
    loadingValidatePromoCode,
    promoFeedback,
    getBlackListEmails,
    emailsInBalckList,
    getContractCustomerInfoFunction,
    loadingContractCustomerInfo,
    getContractCustomerInfo,
    getCountriesFlags,
    countriesFlags,
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    control,
    errors,
    handleSubmit,
    getValues,
    watch,
    clearErrors,
    setValue,
    reset,
  } = useForm({
    mode: 'onChange',
    shouldUnregister: false,
  });

  const [activeStep, setActiveStep] = useState(0);
  const [facturationData, setFacturationData] = useState({});
  const [documentTypesSelect, setDocumentTypesSelect] = useState([]);
  const [documentTypesFiltered, setDocumentTypesFiltered] = useState([]);
  const [departaments, setDepartaments] = useState([]);
  const [departmentAndCities, setDepartmentAndCities] = useState([]);
  const [cities, setCities] = useState([]);
  const [docsForCountry, setDocsForCountry] = useState([]);
  const [invalidDomains, setInvalidDomains] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [snapshot, setSnapshot] = useState(null);
  const [useLocationData, setUseLocationData] = useState(false);
  const [currentCountry, setCurrentCountry] = useState({});
  const items = cartData?.cartItems || [];
  const whatchDepartment = watch('departmentid');
  const whatchPersonType = watch('personType');
  const whatchDocumentType = watch('documentTypeId');
  const whatchCountryId = watch('countryid');
  const currencySymbol = cartData?.currencySymbol || '$';
  const currency = cartData?.currency || 'COP';
  const totalProductos = items.reduce((acc, item) => acc + item.quantity, 0);
  const theme = useTheme();
  const appliedPromos = useSelector(({ license }) => license.appliedPromos) || [];
  const appliedStrings = appliedPromos.map((p) => p.promoCode);

  const totalNeto = items.reduce((acc, item) => {
    const precio = item?.priceUnit ?? 0;
    const cantidad = item?.quantity ?? 0;
    return acc + (precio * cantidad);
  }, 0);

  const valorDescuento = appliedPromos.reduce((acc, promo) => {
    if (promo.offerTypeCode === 'PTJ') {
      return acc + (totalNeto * (promo.offerValue / 100));
    } if (promo.offerTypeCode === 'VLR') {
      return acc + (promo.offerValue || 0);
    }
    return acc;
  }, 0);

  const baseGravable = Math.max(0, totalNeto - valorDescuento);

  const factorAjuste = totalNeto > 0 ? (baseGravable / totalNeto) : 1;

  const totalIva = items.reduce((acc, item) => {
    const precioSubtotal = (item?.priceUnit ?? 0) * (item?.quantity ?? 0);
    const porcentajeIva = item?.taxIva ?? 0;
    return acc + (precioSubtotal * (porcentajeIva / 100));
  }, 0);

  const tieneRetenciones = whatchPersonType === 'J' && items.some((item) => (item?.reteFuentePercentage ?? 0) > 0);

  const totalRetenciones = whatchPersonType === 'J'
    ? items.reduce((acc, item) => {
      const precioSubtotal = (item?.priceUnit ?? 0) * (item?.quantity ?? 0);
      const porcentajeRete = item?.reteFuentePercentage ?? 0;
      return acc + (precioSubtotal * (porcentajeRete / 100));
    }, 0)
    : 0;

  const totalIvaAjustado = totalIva * factorAjuste;
  const totalRetencionesAjustado = totalRetenciones * factorAjuste;

  const granTotal = baseGravable + totalIvaAjustado - totalRetencionesAjustado;

  const getCheckDigit = useCallback((nameDoc) => {
    const numero = getValues(nameDoc);
    if (numero && numero.length === 9 && /^\d{9}$/.test(numero)) {
      const checkDigit = calculateCheckDigit(numero);
      if (checkDigit || checkDigit === 0) {
        return checkDigit;
      }
    }
    return '';
  }, [getValues]);

  /**
   * Reform object from JsonDatabase and generate regex expresions
   * @param {*} array fromdatabase
   * @returns object similar to RHRules.js
   */
  const createRegex = (array) => {
    if (Array.isArray(array)) {
      return array.reduce((acc, item) => {
        // Usamos el id como llave y el resto del objeto como valor
        acc[item.id] = {
          ...item,
          rules: {
            ...item.rules,
            pattern: {
              ...item.rules?.pattern,
              value: item.rules?.pattern?.value ? new RegExp(item.rules?.pattern?.value) : '',
            },
          },
          cleanRegex: item.cleanRegex ? new RegExp(item.cleanRegex, 'g') : '',
          blockRegex: item.blockRegex ? new RegExp(item.blockRegex, 'g') : '',
        };
        return acc;
      }, {});
    }
    return {};
  };

  /**
   * Get rules for input field from system_parameter
   */
  const rulesParams = useMemo(() => {
    if (getParametersMarket && cartData?.countryCode) {
      const rulesParam = getParametersMarket.find(
        (pm) => pm.parameterCode === 'Input_Rules'
          && pm.parameterKey === cartData.countryCode
          && pm.parameterValue,
      );
      if (rulesParam) {
        const rules = JSON.parse(rulesParam.parameterValue);
        if (rules) {
          const rulesWithRegex = createRegex(rules);
          return rulesWithRegex;
        }
      }
    }
    return {};
  }, [getParametersMarket, cartData]);

  const getCodeCountrie = (phoneCode) => {
    if (phoneCode) {
      return `${phoneCode.substring(0, 1)} ${phoneCode.substring(1)}`;
    }
    return '';
  };

  const { flagsCountries, countriesList } = useMemo(() => {
    if (countriesFlags && Array.isArray(countriesFlags)) {
      const flags = countriesFlags.map((c) => ({
        value: c.iso3,
        label: getCodeCountrie(c.phoneCode),
        image: c.flagUrl,
        maxPhoneLength: c.maxPhoneLength,
        minPhoneLength: c.minPhoneLength,
        phoneCode: c.phoneCode,
      }));

      const countries = countriesFlags.map((c) => ({
        value: c.iso3,
        label: c.countryName,
      }));

      return { flagsCountries: flags, countriesList: countries };
    }

    return { flagsCountries: [], countriesList: [] };
  }, [countriesFlags]);

  const passportRules = {
    rules: rulesParams?.passport?.rules ?? RulesAndRegex?.passport?.rules,
    cleanRegex: rulesParams?.passport?.cleanRegex ?? RulesAndRegex?.passport?.cleanRegex,
    blockRegex: rulesParams?.passport?.blockRegex ?? RulesAndRegex?.passport?.blockRegex,
    blockComposing:
      rulesParams?.passport?.blockComposing ?? RulesAndRegex?.passport?.blockComposing,
    maxLength:
      rulesParams?.passport?.rules?.maxLength?.value
      ?? RulesAndRegex?.passport?.rules?.maxLength?.value,
  };

  const nitRules = {
    rules: rulesParams?.NIT?.rules ?? RulesAndRegex?.NIT?.rules,
    cleanRegex: rulesParams?.NIT?.cleanRegex ?? RulesAndRegex?.NIT?.cleanRegex,
    blockRegex: rulesParams?.NIT?.blockRegex ?? RulesAndRegex?.NIT?.blockRegex,
    blockComposing: rulesParams?.NIT?.blockComposing ?? RulesAndRegex?.NIT?.blockComposing,
    maxLength:
      rulesParams?.NIT?.rules?.maxLength?.value ?? RulesAndRegex?.NIT?.rules?.maxLength?.value,
  };

  const defaultRules = {
    rules: rulesParams?.OtherDocuments?.rules
      ?? Rules.otrosDocumentosCustomMessage('El campo debe ser numérico, mínimo 5 y máximo 15 caracteres.'),
    cleanRegex: rulesParams?.OtherDocuments?.cleanRegex ?? RulesAndRegex?.NIT?.cleanRegex,
    blockRegex: rulesParams?.OtherDocuments?.blockRegex ?? RulesAndRegex?.NIT?.blockRegex,
    blockComposing:
      rulesParams?.OtherDocuments?.blockComposing ?? RulesAndRegex?.NIT?.blockComposing,
    maxLength: rulesParams?.OtherDocuments?.maxLength?.value ?? 15,
  };

  useEffect(() => {
    if (whatchDocumentType === 4 && cartData?.countryCode === 'COL') {
      const dv = getCheckDigit('documentNumber');
      setFacturationData((prev) => ({ ...prev, dv }));
    } else {
      setFacturationData((prev) => ({
        ...prev,
        dv: '',
      }));
    }

    // eslint-disable-next-line
  }, [activeStep]);

  /**
   * Each person type have diferent fields
   */
  useEffect(() => {
    if (whatchPersonType) {
      setValue('documentTypeId', '');
      reset({
        ...getValues(),
        documentNumber: '',
        legalName: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        departmentid: '',
        cityid: '',
        fulladdress: '',
        postalCode: '',
        terminos: false,
        countryid: '',
        externalLocation: '',
      });
      clearErrors();
    }
  }, [whatchPersonType, setValue, reset, getValues, clearErrors]);

  useEffect(() => {
    if (whatchDocumentType) {
      reset({
        ...getValues(),
        documentNumber: '',
        legalName: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        departmentid: '',
        cityid: '',
        fulladdress: '',
        postalCode: '',
        terminos: false,
        countryid: '',
        externalLocation: '',
      });
      clearErrors();
    }
  }, [whatchDocumentType, reset, getValues, clearErrors]);

  /**
   * Each document type have a diferent validation
   */
  useEffect(() => {
    if (whatchDocumentType) {
      clearErrors();
    }
    // eslint-disable-next-line
  }, [whatchDocumentType]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch({
      type: SAVE_ORDER_MARKET_ERROR,
      payload: null,
    });
    dispatch({
      type: SET_PROMO_FEEDBACK,
      payload: { message: '', isError: false },
    });
    // eslint-disable-next-line
  }, [activeStep]);

  useEffect(() => {
    if (cartData?.regionCode && cartData?.countryCode) {
      getDocumentTypes();
      getStatesAndCities(cartData.regionCode);
      getParmeterConfig(
        appName,
        'ParametersDocumentType',
        tenant,
      );
      getCatalog(cartData?.countryCode);
      getBlackListEmails();
      getCountriesFlags();
    }
    // eslint-disable-next-line
  }, [cartData?.regionCode, cartData?.countryCode, appName, tenant]);

  useEffect(() => {
    if (statesAndCities?.statesList && statesAndCities.itemsStatesList) {
      const statesWithLabel = statesAndCities.itemsStatesList.map(
        (item) => ({ value: item.value, label: item.text }),
      );
      const citiesWithLabel = statesAndCities.statesList.map(
        (department) => ({
          id: department.id,
          city: department.city.map((city) => ({
            value: city.id,
            label: city.cityName,
          })),
        }),
      );
      setDepartmentAndCities(citiesWithLabel);
      setDepartaments(statesWithLabel);
    }
  }, [statesAndCities]);

  useEffect(() => {
    if (whatchDepartment) {
      setValue('cityid', '');
      const currentDepartment = departmentAndCities.find(
        (departament) => departament.id === whatchDepartment,
      );
      if (currentDepartment?.city) {
        setCities(currentDepartment.city);
      } else {
        setCities([]);
      }
    } else {
      setCities([]);
      setValue('cityid', '');
      clearErrors('cityid');
    }
    // eslint-disable-next-line
  }, [whatchDepartment, departmentAndCities]);

  useEffect(() => {
    if (whatchPersonType && docsForCountry.length > 0) {
      setValue('documentTypeId', '');
      const typeFilter = docsForCountry.filter(
        (docfc) => docfc[1]?.allowPersonType.includes(whatchPersonType),
      );
      const selectFilter = documentTypesSelect.filter((doct) => typeFilter.some((tf) => tf[0] === doct.identifier));
      if (selectFilter.length > 0) {
        setDocumentTypesFiltered(selectFilter);
      }
    }
    // eslint-disable-next-line
  }, [whatchPersonType, docsForCountry, documentTypesSelect, documentTypes]);

  useEffect(() => {
    if (documentTypes?.length > 0) {
      const documentTypesChanged = documentTypes.map((doc) => ({
        identifier: doc.documentTypeCode,
        value: doc.id,
        label: doc.documentTypeDesciption,
      }));
      setDocumentTypesSelect(documentTypesChanged);
    }
  }, [documentTypes]);

  useEffect(() => {
    const keys = Object.keys(parameterApp);
    if (keys.length > 0 && documentTypesSelect.length > 0) {
      const arrayDocs = Object.entries(parameterApp);
      const documentTypesFromCountry = arrayDocs.filter(
        (doc) => doc[1]?.country === cartData?.countryCode,
      );
      if (docsForCountry.length === 0) {
        setDocsForCountry(documentTypesFromCountry);
      }
      const documentsWithCountryLabel = documentTypesSelect
        .filter((doc) => documentTypesFromCountry.some((docfc) => docfc[0] === doc.identifier))
        .map((doc) => {
          const foundEntry = documentTypesFromCountry.find((docE) => docE[0] === doc.identifier);
          return {
            ...doc,
            label: foundEntry?.[1].countryDescription || doc.label,
          };
        });
      if (documentTypesFiltered.length === 0
        || documentTypesSelect[0]?.label
        !== documentsWithCountryLabel[0]?.label
      ) {
        setDocumentTypesSelect(documentsWithCountryLabel);
      }
    }
    // eslint-disable-next-line
  }, [parameterApp, documentTypes, cartData, docsForCountry.length, documentTypesSelect.length, documentTypesFiltered.length]);

  useEffect(() => {
    if (items.length > 0 && !snapshot) {
      setSnapshot(JSON.stringify(items));
    }
  }, [items, snapshot]);

  useEffect(() => {
    if (!snapshot) return;

    const handleUnload = () => {
      if (JSON.stringify(items) !== snapshot) {
        const formattedCartItems = items.map((item) => ({
          packageCode: item.packageCode,
          quantity: item.quantity,
          validityPeriod: item.validityPeriod,
          validityType: item.validityTypeId,
          deviceCode: item.deviceTypeCode,
        }));

        const payload = {
          countryCode: cartData?.countryCode,
          regionCode: cartData?.regionCode,
          transactionCode: code,
          cartItems: formattedCartItems,
        };

        cartAddEmergency(payload);
      }
    };

    const handlePageShow = (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    };

    window.addEventListener('pagehide', handleUnload);
    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pagehide', handleUnload);
      window.removeEventListener('pageshow', handlePageShow);
    };
    // eslint-disable-next-line
  }, [items, snapshot, code]);

  useEffect(() => {
    if (!licenseLoadingSaveOrder && licenseSaveOrderSuccess) {
      sendToePaycoPaymentMarket(
        saveOrderSuccess?.token,
        saveOrderSuccess?.documentType,
        saveOrderSuccess?.documentNumber,
        saveOrderSuccess?.epaycoPaymentCode,
        saveOrderSuccess?.paymentGateway,
        saveOrderSuccess?.checkoutRedirectUrl,
      );
    }
    // eslint-disable-next-line
  }, [licenseLoadingSaveOrder, licenseSaveOrderSuccess]);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      dispatch({
        type: SET_PROMO_FEEDBACK,
        payload: { message: '', isError: false },
      });
    }
    // eslint-disable-next-line
  }, [errors]);

  useEffect(() => {
    if (emailsInBalckList) {
      const invalidsDomains = [];
      emailsInBalckList.forEach((email) => {
        invalidsDomains.push(email.regla);
      });
      setInvalidDomains(invalidsDomains);
    }
  }, [emailsInBalckList]);

  useEffect(() => {
    if (getContractCustomerInfo && Object.keys(getContractCustomerInfo).length > 0) {
      setTimeout(() => {
        if (whatchPersonType === 'J') {
          setValue('legalName', getContractCustomerInfo.legalName || '');
          setValue('firstName', '');
          setValue('lastName', '');
        } else {
          setValue('firstName', getContractCustomerInfo.firstName || '');
          setValue('lastName', getContractCustomerInfo.lastName || '');
          setValue('legalName', '');
        }
        setValue('email', getContractCustomerInfo.email || '');
        const matchedCountry = flagsCountries.find((c) => c.phoneCode === getContractCustomerInfo?.countryCallingCode && c.value === getContractCustomerInfo?.countryCallingIso3);
        if (matchedCountry) {
          setCurrentCountry(matchedCountry);
          setValue('indicative', matchedCountry.value);
        }
        setValue('phone', getContractCustomerInfo.cellphoneNumber || '');
        if (getContractCustomerInfo.departmentId || getContractCustomerInfo.cityId) {
          setValue('countryid', '');
          setValue('externalLocation', '');
          setValue('departmentid', getContractCustomerInfo.departmentId || '');
          const currentDepartment = departmentAndCities?.find(
            (departament) => departament?.id === getContractCustomerInfo.departmentId,
          );
          if (currentDepartment?.city) {
            setCities(currentDepartment.city);
          } else {
            setCities([]);
          }
          setValue('cityid', getContractCustomerInfo.cityId || '');
          setUseLocationData(false);
        } else {
          setValue('departmentid', '');
          setValue('cityid', '');
          if (getContractCustomerInfo.countryLocationIso3 || getContractCustomerInfo.locationData) {
            setUseLocationData(true);
            setValue('countryid', getContractCustomerInfo.countryLocationIso3 || '');
            setValue('externalLocation', getContractCustomerInfo.locationData || '');
          }
        }
        setValue('fulladdress', getContractCustomerInfo.fullAddress || '');
        setValue('postalCode', getContractCustomerInfo.postalCode || '');
      }, 100);
    }
  }, [getContractCustomerInfo, setValue]);

  useEffect(() => {
    if (flagsCountries?.length > 0 && cartData?.countryCode) {
      const currentCount = flagsCountries.find((cou) => cou.value === cartData?.countryCode);
      if (currentCount) {
        setCurrentCountry(currentCount);
        setValue('indicative', currentCount.value);
      }
    }
  }, [flagsCountries, cartData?.countryCode]);

  const removeItem = (identifierCode) => {
    removeCartItem(identifierCode);
    if (items.length === 1) {
      const payload = {
        countryCode: cartData?.countryCode,
        regionCode: cartData?.regionCode,
        transactionCode: code,
        cartItems: [],
      };
      cartAdd(payload);
      dispatch({
        type: GET_CART_ERROR,
        payload: { hasError: false, url: cartData?.urlMarketPlace },
      });
    }
  };

  const getDepartmentName = (departmentId) => {
    const department = departaments.find(
      (currentDep) => currentDep.value === departmentId,
    );
    return department?.label;
  };

  const getCityName = (cityId) => {
    const department = departmentAndCities.find(
      (currentDep) => currentDep?.id === whatchDepartment,
    );
    const city = department?.city?.find(
      (currentCity) => currentCity.value === cityId,
    );
    return city?.label;
  };

  const getDocumentTypeCode = (idDoc) => {
    const doc = documentTypesFiltered?.find(
      (currentDoc) => currentDoc?.value === idDoc,
    );
    return doc?.identifier;
  };

  const preparePayload = (form, cart) => ({
    customerBilling: {
      personType: form.personType,
      documentTypeId: form.documentTypeId,
      documentTypeCode: getDocumentTypeCode(form.documentTypeId) || '',
      documentNumber: form.documentNumber,
      dv: form.dv || '',
      legalName: form.personType === 'J' ? form.legalName : '',
      firstName: form.personType === 'N' ? form.firstName : '',
      lastName: form.personType === 'N' ? form.lastName : '',
      cellphoneNumber: form.phone || '',
      email: form.email,
      departmentId: form.departmentid || null,
      cityId: form.cityid || null,
      fullAddress: form.fulladdress || null,
      addressAdditionalInformation: form?.aditionalInfo || '',
      countryCallingCode: currentCountry?.phoneCode || '',
      countryCallingIso3: form?.indicative || '',
      postalCode: form?.postalCode || '',
      CountryLocationIso3: form?.countryid || '',
      locationData: form?.externalLocation || '',
    },
    itemsCart: cart.cartItems.map((item) => ({
      packageId: item.packageId,
      packageCode: item.packageCode,
      packageQuantity: item.quantity,
      validityPeriod: item.validityPeriod,
      validityTypeId: item.validityTypeId,
      identifierCode: item.identifierCode,
      deviceCode: item.deviceTypeCode,
      packageValidityId: item.packageValidityId,
    })),
    transactionCode: code,
    promotionCode: appliedStrings,
    paymentMethod: 'EN_LINEA',
    countryCode: cart.countryCode,
    regionCode: cart.regionCode,
  });

  const handleNext = () => {
    if (activeStep === 1) {
      setFacturationData(getValues());
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 2) {
      const finalPayload = preparePayload(facturationData, cartData);
      saveOrder(finalPayload);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const getValidityLabel = (type, period) => {
    const labels = {
      A: period === 1 ? 'año' : 'años',
      M: period === 1 ? 'mes' : 'meses',
      D: period === 1 ? 'día' : 'días',
      H: period === 1 ? 'hora' : 'horas',
      I: 'Ilimitada',
    };
    return labels[type] || '';
  };

  const getMaxQty = () => {
    const foundParam = getParametersMarket?.find(
      (param) => param?.parameterCode === 'Quantity_Max'
        && param.parameterKey?.toUpperCase() === tenant?.toUpperCase(),
    );
    const parsed = parseInt(foundParam?.parameterValue, 10);
    return !isNaN(parsed) ? parsed : 100;
  };

  const percentageValueIva = () => {
    const foundParam = getParametersMarket?.find(
      (param) => param?.parameterCode === 'Percentage_Iva'
        && param.parameterKey?.toUpperCase() === tenant?.toUpperCase(),
    );
    const rawValue = foundParam?.parameterValue;
    return (typeof rawValue === 'string' && rawValue.trim() !== '')
      ? rawValue
      : '15%';
  };

  const nameCountry = () => {
    const rulesParam = getParametersMarket?.find(
      (pm) => pm?.parameterCode === 'URL_Market' && pm?.parameterKey === cartData?.countryCode,
    );
    return rulesParam?.parameterDescription ?? '';
  };

  const updateQuantity = (identifierCode, delta) => {
    updateCartQuantity(identifierCode, delta, getMaxQty());
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    setOpenEditDialog(true);
  };

  const handleSaveEdit = () => {
    const newId = `${selectedItem.packageCode}_${selectedItem.deviceTypeCode}_${selectedItem.validityPeriod}${selectedItem.validityTypeId}`;

    const duplicateItem = cartData.cartItems.find(
      (item) => item.identifierCode === newId && item.identifierCode !== selectedItem.identifierCode,
    );

    if (duplicateItem) {
      removeCartItem(selectedItem.identifierCode);
      updateCartQuantity(duplicateItem.identifierCode, selectedItem.quantity, getMaxQty());
    } else {
      updateCartItem({
        oldId: selectedItem.identifierCode,
        newItem: {
          ...selectedItem,
          identifierCode: newId,
        },
      });
    }

    setOpenEditDialog(false);
  };

  const allProducts = getItemsCatalog?.flatMap((cat) => cat.productsList || []) || [];

  const currentProductInCatalog = allProducts.find((group) => group.groupCode === selectedItem?.groupCode);
  const availableDevices = [
    ...new Set(
      currentProductInCatalog?.prices
        .map((pr) => pr.deviceCode),
    ),
  ];

  const availableVigencias = currentProductInCatalog?.prices.filter(
    (pr) => pr.deviceCode === selectedItem?.deviceTypeCode,
  ) || [];

  const handleDeviceChange = (newDeviceCode) => {
    if (!currentProductInCatalog) return;

    let newPriceInfo = currentProductInCatalog.prices.find(
      (pr) => pr.deviceCode === newDeviceCode && pr.validityPeriod === selectedItem?.validityPeriod,
    );
    if (!newPriceInfo) {
      newPriceInfo = currentProductInCatalog.prices.find((pr) => pr.deviceCode === newDeviceCode);
    }

    if (newPriceInfo) {
      setSelectedItem({
        ...selectedItem,
        deviceTypeCode: newDeviceCode,
        packageId: newPriceInfo.packageId,
        packageCode: newPriceInfo.packageCode,
        packagePrice: newPriceInfo.packagePrice,
        priceUnit: newPriceInfo.priceUnit,
        taxIva: newPriceInfo.taxIva,
        validityPeriod: newPriceInfo.validityPeriod,
        packageValidityId: newPriceInfo.packageValidityId ?? null,
      });
    }
  };

  const handleValidityChange = (newPeriod) => {
    const periodNum = parseInt(newPeriod, 10);
    const newPriceInfo = currentProductInCatalog?.prices.find(
      (p) => p.validityPeriod === periodNum && selectedItem?.deviceTypeCode === p.deviceCode,
    );

    if (newPriceInfo) {
      setSelectedItem({
        ...selectedItem,
        validityPeriod: periodNum,
        packageId: newPriceInfo.packageId,
        packageCode: newPriceInfo.packageCode,
        packagePrice: newPriceInfo.packagePrice,
        priceUnit: newPriceInfo.priceUnit,
        taxIva: newPriceInfo.taxIva,
        packageValidityId: newPriceInfo.packageValidityId ?? null,
      });
    }
  };

  const getDeviceLabel = (codeDevice) => {
    const deviceLabelsParam = getParametersMarket?.find(
      (param) => param?.parameterCode === 'Device_Labels'
      && param.parameterKey?.toUpperCase() === tenant?.toUpperCase()
      && param.parameterValue?.toUpperCase() === codeDevice?.toUpperCase(),
    );

    if (deviceLabelsParam?.parameterDescription) {
      return deviceLabelsParam.parameterDescription;
    }

    const defaultLabels = {
      FC: 'Centralizado',
      TK: 'Token',
      P12: 'P12',
    };

    return defaultLabels[codeDevice] || 'Desconocido';
  };

  const isDataReady = statesAndCities !== undefined
    && documentTypes.length > 0
    && Object.keys(parameterApp).length > 0
    && !loadingMarketPlace
    && getParametersMarket.length > 0
    && rulesParams
    && emailsInBalckList
    && countriesFlags.length > 0;

  useEffect(() => {
    if (isDataReady) {
      onReady();
    }
  }, [isDataReady, onReady]);

  useEffect(() => {
    if (whatchCountryId || whatchCountryId === '') {
      setValue('externalLocation', '');
    }
  }, [whatchCountryId]);

  if (!isDataReady) return null;

  /**
   * Rules changed by document type
   * @param {*} persontype Natural o legal
   * @param {*} watchDocType NIT, Passport,CC ....
   * @returns a validation for these documetn type
   */
  const getValidationsByDocumentType = (persontype, watchDocType) => {
    if (watchDocType === 6 || watchDocType === 10 || watchDocType === 13) {
      return passportRules;
    } if (watchDocType === 4 && persontype === 'J') {
      return nitRules;
    }
    return defaultRules;
  };

  const getColorForCheckBox = (value) => {
    if (errors?.terminos) {
      return theme.palette.error.main;
    }
    if (value) {
      return theme.palette.primary.main;
    }
    return theme.body.form2.textColor;
  };

  /**
   * Sanitizes the input value by removing characters that don't match the regex.
   * @param {string} inputValue - The current value of the input (e.g., firstName).
   * @param {RegExp} cleanRegex - The allowed pattern; non-matching characters will be removed.
  */
  const cleanInput = (inputValue, cleanRegex) => {
    const originalValue = getValues(inputValue);
    const cleanValue = originalValue?.replace(cleanRegex, '');
    setValue(inputValue, cleanValue);
    clearErrors();
    if (inputValue === 'documentNumber' && !errors.documentNumber && whatchPersonType && whatchDocumentType && cleanValue) {
      getContractCustomerInfoFunction(whatchPersonType, whatchDocumentType, cleanValue, cartData?.countryCode, true);
    }
  };

  const formatMoney = (value) => (value ?? 0).toLocaleString('es-CO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  /**
   * Create rule with invalid domins list
   * @param {*} value entry of user example: email@yopmail.com
   * @returns true if there is no problem, message if domain is invalid
   */
  const validateEmail = (value) => {
    if (!value) {
      return true;
    }
    // Verify if email have a domain in black list
    const domain = value.split('@')[1];
    if (domain && invalidDomains.includes(`@${domain}`)) {
      return 'El dominio de correo ingresado no es permitido.';
    }
    return true;
  };

  const handleToggleLocation = (checked) => {
    setUseLocationData(checked);
    setValue('departmentid', '');
    setValue('cityid', '');
    setValue('countryid', '');
    setValue('externalLocation', '');

    clearErrors([
      'departmentid',
      'cityid',
      'countryid',
      'externalLocation',
    ]);
  };

  return (
    <>
      {items.length === 0 ? (
        <Warning />
      )
        : (
          <>
            <Container maxWidth="lg" className={classes.mainContent}>
              {activeStep !== 0 && (
                <Box
                  onClick={() => {
                    clearErrors();
                    setActiveStep(activeStep - 1);
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: licenseLoadingSaveOrder ? 'default' : 'pointer',
                    color: theme.palette.primary.main,
                    marginBottom: '12px',
                    width: 'fit-content',
                    pointerEvents: licenseLoadingSaveOrder ? 'none' : 'auto',
                    opacity: licenseLoadingSaveOrder ? 0.5 : 1,
                  }}
                >
                  <ArrowBack
                    style={{
                      fontSize: '13px',
                      marginRight: '4px',
                      fontWeight: 'bold',
                    }}
                  />
                  <Typography style={{
                    fontWeight: 600,
                    fontSize: '16px',
                    letterSpacing: 0,
                    fontFamily: '"Karla"',
                  }}
                  >
                    Atrás
                  </Typography>
                </Box>
              )}
              <Stepper
                activeStep={activeStep}
                className={classes.stepper}
                alternativeLabel
                connector={(
                  <StepConnector
                    classes={{
                      active: classes.connectorActive,
                      completed: classes.connectorCompleted,
                      disabled: classes.connectorDisabled,
                      line: classes.connectorLine,
                    }}
                  />
                )}
              >
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel className={classes.stepLabel}>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <Box className={classes.stepContainer}>
                {activeStep === 0 && (
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={8}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                          padding: '14px 18px',
                          backgroundColor: theme.body.maximumProductAlert.backgroundColor,
                          border: `1px solid ${theme.body.maximumProductAlert.border}`,
                          borderRadius: '14px',
                          marginBottom: '24px',
                        }}
                      >
                        <img
                          src={InfoIcon}
                          alt="Info"
                          style={{ width: '24px', height: '24px' }}
                        />

                        <Typography
                          style={{
                            color: theme.body.maximumProductAlert.textColor, fontFamily: '"Raleway"', fontWeight: 500, fontSize: '14px', lineHeight: '20px', letterSpacing: 0,
                          }}
                          sx={{
                            fontSize: '14px',
                            color: theme.body.maximumProductAlert.textColor,
                            fontWeight: 500,
                            lineHeight: 1.4,
                          }}
                        >
                          Ten en cuenta que puedes agregar al carrito un total máximo de
                          {' '}
                          {getMaxQty()}
                          {' '}
                          unidades por producto.
                        </Typography>
                      </Box>
                      {items.map((item, index) => (
                        <Box key={index} className={classes.productCard}>
                          <Box
                            style={{
                              flexGrow: 1,
                              width: '100%',
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '12px',
                            }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                            >
                              <img
                                src={item?.imagePackageUrl || iconoProducto}
                                alt="Producto"
                                style={{
                                  objectFit: 'contain', marginRight: '12px',
                                }}
                              />
                              <Typography
                                style={{
                                  fontWeight: 700,
                                  color: theme.header.badgeItems.color,
                                  fontSize: '1.25rem',
                                  lineHeight: '1.6rem',
                                  verticalAlign: 'middle',
                                  letterSpacing: 0,
                                  fontFamily: '"Karla"',
                                }}
                              >
                                {item.packageDescription}
                              </Typography>
                            </Box>
                            <Box
                              display="flex"
                              alignItems="center"
                              sx={{ '@media (max-width:600px)': { justifyContent: 'center', textAlign: 'center' } }}
                            >
                              <Typography
                                style={{
                                  color: theme.body.cart.products.text,
                                  fontSize: '16px',
                                  fontWeight: 400,
                                  marginTop: '4px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  flexWrap: 'wrap',
                                  letterSpacing: 0,
                                  fontFamily: '"Raleway"',
                                }}
                              >
                                <span style={{ marginRight: '16px' }}>
                                  Vigencia:
                                  {' '}
                                  {item.validityTypeId === 'I'
                                    ? 'Ilimitada'
                                    : `${item.validityPeriod} ${getValidityLabel(item.validityTypeId, item.validityPeriod)}`}
                                </span>

                                <span>
                                  Formato:
                                  {' '}
                                  {getDeviceLabel(item.deviceTypeCode)}
                                </span>
                              </Typography>
                              <IconButton
                                size="small"
                                style={{
                                  marginLeft: '12px',
                                  padding: '6px',
                                  color: theme.palette.primary.main,
                                }}
                                onClick={() => handleEditClick(item)}
                                disabled={loadingViewMore}
                              >
                                <EditIcon
                                  style={{
                                    width: '24px',
                                    height: '24px',
                                    opacity: 1,
                                  }}
                                />
                              </IconButton>
                            </Box>
                            <Box sx={{ '@media (max-width:600px)': { textAlign: 'center' } }}>
                              <Typography style={{
                                color: theme.body.cart.products.text, fontSize: '16px', fontWeight: 400, fontFamily: '"Raleway"', letterSpacing: 0,
                              }}
                              >
                                Valor unitario:
                                {' '}
                                <span style={{ fontFamily: '"Karla"', letterSpacing: 0 }}>
                                  {currencySymbol}
                                  {' '}
                                  {formatMoney(item.priceUnit).toLocaleString()}
                                  {' '}
                                  {currency}
                                </span>
                              </Typography>
                            </Box>
                            <Box
                              display="flex"
                              alignItems="center"
                              sx={{ '@media (max-width:600px)': { flexDirection: 'column', gap: 1, alignItems: 'center' } }}
                            >
                              <Typography style={{
                                color: theme.body.cart.products.text, fontSize: '1rem', fontWeight: 400, marginRight: '12px', fontFamily: '"Raleway"', letterSpacing: 0,
                              }}
                              >
                                Cantidad
                              </Typography>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                style={{
                                  width: '132px',
                                  height: '52px',
                                  backgroundColor: theme.palette.primary.contrastText,
                                  borderRadius: '10px',
                                  padding: '0 16px',
                                  border: `1px solid ${theme.body.form2.border}`,
                                  boxSizing: 'border-box',
                                }}
                              >
                                <IconButton
                                  onClick={() => updateQuantity(item.identifierCode, -1)}
                                  size="small"
                                  style={{
                                    color: theme.body.cart.products.text,
                                    padding: '8px',
                                  }}
                                  disabled={loadingViewMore}
                                >
                                  <Box
                                    style={{
                                      width: '12px',
                                      height: '2px',
                                      backgroundColor: 'currentColor',
                                      borderRadius: '2px',
                                    }}
                                  />
                                </IconButton>
                                <Input
                                  value={item.quantity}
                                  disableUnderline
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === '') {
                                      updateQuantity(item.identifierCode, -item.quantity + 1);
                                      return;
                                    }
                                    const num = parseInt(val, 10);
                                    if (!isNaN(num)) {
                                      const max = getMaxQty();
                                      const target = Math.min(num, max);
                                      const delta = target - item.quantity;
                                      updateQuantity(item.identifierCode, delta);
                                    }
                                  }}
                                  inputProps={{
                                    style: {
                                      textAlign: 'center',
                                      fontFamily: 'Inter, sans-serif',
                                      fontWeight: 500,
                                      fontSize: '16px',
                                      color: theme.body.cart.products.text,
                                      width: '40px',
                                      padding: 0,
                                    },
                                  }}
                                />
                                <IconButton
                                  onClick={() => updateQuantity(item.identifierCode, 1)}
                                  size="small"
                                  style={{
                                    color: theme.body.cart.products.text,
                                    padding: '8px',
                                  }}
                                  disabled={loadingViewMore}
                                >
                                  <Box
                                    style={{
                                      position: 'relative',
                                      width: '12px',
                                      height: '12px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <Box style={{
                                      position: 'absolute', width: '12px', height: '2px', backgroundColor: 'currentColor', borderRadius: '2px',
                                    }}
                                    />
                                    <Box style={{
                                      position: 'absolute', width: '2px', height: '12px', backgroundColor: 'currentColor', borderRadius: '2px',
                                    }}
                                    />
                                  </Box>
                                </IconButton>
                              </Box>
                            </Box>
                          </Box>
                          <Box className={classes.priceBlock}>
                            <IconButton
                              onClick={() => removeItem(item.identifierCode)}
                              style={{ color: theme.palette.primary.main }}
                              size="small"
                              disabled={loadingViewMore}
                            >
                              <DeleteOutlineIcon />
                            </IconButton>
                            <Box sx={{ textAlign: 'right', '@media (max-width:600px)': { textAlign: 'center' } }}>
                              <Typography
                                style={{
                                  color: theme.body.cart.products.text,
                                  display: 'block',
                                  fontWeight: 500,
                                  fontSize: '16px',
                                  letterSpacing: 0,
                                  fontFamily: '"Raleway"',
                                }}
                              >
                                Subtotal
                                {' '}
                                <span style={{ fontFamily: '"Karla"', fontWeight: 500 }}>
                                  {`(${item.quantity} ${item?.quantity > 1 ? 'unidades' : 'unidad'})`}
                                </span>
                              </Typography>
                              <Box
                                style={{
                                  display: 'flex',
                                  justifyContent: 'end',
                                  gap: '4px',
                                }}
                              >
                                <OwnTypographySubtotal
                                  style={{
                                    fontWeight: 700,
                                    letterSpacing: 0,
                                    fontFamily: '"Karla"',
                                  }}
                                >
                                  {`${currencySymbol} ${(formatMoney(item.priceUnit * item.quantity).toLocaleString())}`}
                                </OwnTypographySubtotal>
                                <OwnTypographySubtotal
                                  style={{
                                    fontWeight: 400,
                                    letterSpacing: 0,
                                    fontFamily: '"Karla"',
                                  }}
                                >
                                  {`${currency}`}
                                </OwnTypographySubtotal>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    </Grid>
                    <PurchaseSummary
                      totalProductos={totalProductos}
                      totalNeto={totalNeto}
                      handleNext={handleNext}
                      currencySymbol={currencySymbol}
                      activeStep={activeStep}
                      totalIva={totalIvaAjustado}
                      totalRetenciones={totalRetencionesAjustado}
                      granTotal={granTotal}
                      currency={currency}
                      items={items}
                      cartData={cartData}
                      code={code}
                      loadingViewMore={loadingViewMore}
                      setLoadingViewMore={setLoadingViewMore}
                      saveOrderMarketError={saveOrderMarketError}
                      appliedStrings={appliedStrings}
                      valorDescuento={valorDescuento}
                      loadingValidatePromoCode={loadingValidatePromoCode}
                      promoFeedback={promoFeedback}
                      rulesPromoCode={rulesParams.promotionalCode}
                      percentageIva={percentageValueIva()}
                      tieneRetenciones={tieneRetenciones}
                    />
                  </Grid>
                )}

                {activeStep === 1 && (
                  <>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={8}>
                        <OwnCard>
                          <CardContent style={{ width: '100%' }}>
                            <Grid container spacing={2}>
                              <Grid item md={12}>
                                <OwnTypography>
                                  Datos de facturación
                                </OwnTypography>
                              </Grid>
                              <Grid item xs={12} md={6} lg={4}>
                                <OwnCustomSelect
                                  label="Tipo de persona"
                                  name="personType"
                                  options={[
                                    { value: 'N', label: 'Natural' },
                                    { value: 'J', label: 'Jurídica' },
                                  ]}
                                  control={control}
                                  rule={Rules.required}
                                  required
                                  error={errors}
                                  // set new icon for marquteplace letmi
                                  iconExpandMore={ExpandMoreIcon}
                                  disabled={loadingContractCustomerInfo}
                                  styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                  className={classes.customSelectFont}
                                  inputProps={{
                                    MenuProps: { classes: { paper: classes.menuFont } },
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={4}>
                                <OwnCustomSelect
                                  label="Tipo de documento"
                                  name="documentTypeId"
                                  options={documentTypesFiltered}
                                  control={control}
                                  rule={Rules.required}
                                  required
                                  error={errors}
                                  iconExpandMore={ExpandMoreIcon}
                                  noWrap
                                  disabled={loadingContractCustomerInfo}
                                  styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                  className={classes.customSelectFont}
                                  inputProps={{
                                    MenuProps: { classes: { paper: classes.menuFont } },
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={4}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <div style={{ flexGrow: 1 }}>
                                    <OwnCustomInput
                                      label="Número de identificación"
                                      name="documentNumber"
                                      control={control}
                                      disabled={loadingContractCustomerInfo}
                                      styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                      onValidate={() => {
                                        const currentValues = getValues();
                                        const hasData = currentValues.legalName
                                          || currentValues.firstName
                                          || currentValues.lastName
                                          || currentValues.email
                                          || currentValues.phone;
                                        if (hasData) {
                                          reset({
                                            ...currentValues,
                                            legalName: '',
                                            firstName: '',
                                            lastName: '',
                                            email: '',
                                            phone: '',
                                            departmentid: '',
                                            cityid: '',
                                            fulladdress: '',
                                            postalCode: '',
                                            terminos: false,
                                            countryid: '',
                                            externalLocation: '',
                                          });
                                          clearErrors();
                                        }
                                      }}
                                      rule={
                                        getValidationsByDocumentType(
                                          whatchPersonType,
                                          whatchDocumentType,
                                        )?.rules
                                      }
                                      error={errors}
                                      required
                                      inputProps={{
                                        maxLength: getValidationsByDocumentType(
                                          whatchPersonType,
                                          whatchDocumentType,
                                        )?.maxLength,
                                      }}
                                      cleanInputPattern={getValidationsByDocumentType(
                                        whatchPersonType,
                                        whatchDocumentType,
                                      )?.cleanRegex}
                                      blockComposing={getValidationsByDocumentType(
                                        whatchPersonType,
                                        whatchDocumentType,
                                      )?.blockComposing}
                                      onBlur={() => {
                                        cleanInput('documentNumber', getValidationsByDocumentType(whatchPersonType, whatchDocumentType)?.cleanRegex);
                                      }}
                                      className={classes.styleInputs}
                                    />
                                  </div>
                                  {loadingContractCustomerInfo && (
                                    <div style={{ marginLeft: '10px', minWidth: '20px' }}>
                                      <CircularProgress size={20} color="primary" />
                                    </div>
                                  )}
                                </div>
                              </Grid>
                              {whatchPersonType === 'J' ? (
                                <Grid item xs={12} md={6} lg={12}>
                                  <OwnCustomInput
                                    label="Razón social"
                                    name="legalName"
                                    control={control}
                                    error={errors}
                                    styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                    rule={rulesParams?.companyName?.rules
                                      ?? Rules.letrasTildes}
                                    required
                                    inputProps={{
                                      maxLength:
                                        rulesParams?.companyName?.rules?.maxLength?.value
                                        ?? RulesAndRegex?.namescompanyNameAndSurnames?.rules?.maxLength?.value,
                                    }}
                                    cleanInputPattern={
                                      RulesAndRegex?.companyName?.cleanRegex
                                    }
                                    blockComposing={
                                      RulesAndRegex?.companyName?.blockComposing
                                    }
                                    onBlur={() => {
                                      cleanInput('legalName', RulesAndRegex?.companyName?.cleanRegex);
                                    }}
                                    className={classes.customSelectFont}
                                  />
                                </Grid>
                              ) : (
                                <>
                                  <Grid item xs={12} md={6} lg={6}>
                                    <OwnCustomInput
                                      label="Nombres"
                                      name="firstName"
                                      control={control}
                                      error={errors}
                                      styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                      rule={
                                        rulesParams?.namesAndSurnames?.rules
                                        ?? Rules?.letrasTildes
                                      }
                                      required
                                      inputProps={{
                                        maxLength:
                                          rulesParams?.namesAndSurnames?.rules?.maxLength?.value
                                          ?? RulesAndRegex?.namesAndSurnames?.rules?.maxLength?.value,
                                      }}
                                      cleanInputPattern={
                                        rulesParams?.namesAndSurnames?.cleanRegex
                                        ?? RulesAndRegex?.namesAndSurnames?.cleanRegex
                                      }
                                      blockComposing={
                                        rulesParams?.namesAndSurnames?.blockComposing
                                        ?? RulesAndRegex?.namesAndSurnames?.blockComposing
                                      }
                                      onBlur={() => {
                                        cleanInput(
                                          'firstName',
                                          rulesParams?.namesAndSurnames?.cleanRegex
                                          ?? RulesAndRegex?.namesAndSurnames?.cleanRegex,
                                        );
                                      }}
                                      className={classes.customSelectFont}
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={6} lg={6}>
                                    <OwnCustomInput
                                      label="Apellidos"
                                      name="lastName"
                                      control={control}
                                      error={errors}
                                      styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                      rule={
                                        rulesParams?.namesAndSurnames?.rules
                                        ?? Rules?.letrasTildes
                                      }
                                      required
                                      inputProps={{
                                        maxLength:
                                          rulesParams?.namesAndSurnames?.rules?.maxLength?.value
                                          ?? RulesAndRegex?.namesAndSurnames?.rules?.maxLength?.value,
                                      }}
                                      cleanInputPattern={
                                        rulesParams?.namesAndSurnames?.cleanRegex
                                        ?? RulesAndRegex?.namesAndSurnames?.cleanRegex
                                      }
                                      blockComposing={
                                        rulesParams?.namesAndSurnames?.blockComposing
                                        ?? RulesAndRegex?.namesAndSurnames?.blockComposing
                                      }
                                      onBlur={() => {
                                        cleanInput('lastName',
                                          RulesAndRegex?.namesAndSurnames?.cleanRegex
                                          ?? RulesAndRegex?.namesAndSurnames?.cleanRegex);
                                      }}
                                      className={classes.customSelectFont}
                                    />
                                  </Grid>
                                </>
                              )}
                              <Grid
                                item
                                xs={12}
                                md={whatchPersonType === 'J' ? 12 : 6}
                                lg={12}
                              >
                                <OwnCustomInput
                                  label="Correo"
                                  name="email"
                                  control={control}
                                  rule={{
                                    ...rulesParams?.email?.rules,
                                    validate: validateEmail,
                                  }}
                                  error={errors}
                                  styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                  required
                                  inputProps={{
                                    maxLength:
                                      rulesParams?.email?.rules?.maxLength?.value
                                      ?? RulesAndRegex?.email?.rules?.maxLength?.value,
                                  }}
                                  className={classes.customSelectFont}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <OwnCustomAutocompleteImage
                                  label="Indicativo"
                                  name="indicative"
                                  options={flagsCountries || []}
                                  control={control}
                                  rule={Rules.required}
                                  required
                                  error={errors}
                                  iconExpandMore={<ExpandMoreIcon />}
                                  noWrap
                                  disabled={loadingContractCustomerInfo}
                                  styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                  className={classes.customSelectFont}
                                  inputProps={{
                                    MenuProps: { classes: { paper: classes.menuFont } },
                                  }}
                                  onChange={(value) => {
                                    setValue('phone', '');
                                    const country = flagsCountries.find(
                                      (item) => item.value === value,
                                    );
                                    setCurrentCountry(country);
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                md={8}
                              >
                                <OwnCustomInput
                                  label="Número móvil"
                                  name="phone"
                                  control={control}
                                  rule={{
                                    // ...rulesParams?.cellPhone?.rules ?? RulesAndRegex?.cellPhone?.rules,
                                    required: 'Campo obligatorio',
                                    validate: (value) => {
                                      const minLengthRequired = currentCountry?.minPhoneLength;
                                      if (!minLengthRequired) return true;
                                      if (value && value.length < minLengthRequired) {
                                        return `Mínimo ${minLengthRequired} caracteres para este país`;
                                      }
                                      return true;
                                    },
                                  }}
                                  error={errors}
                                  styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                  required
                                  inputProps={{
                                    maxLength: currentCountry?.maxPhoneLength,
                                  }}
                                  cleanInputPattern={
                                    rulesParams?.cellPhone?.cleanRegex
                                    ?? RulesAndRegex?.cellPhone?.cleanRegex
                                  }
                                  blockComposing={
                                    rulesParams?.cellPhone?.blockComposing
                                    ?? RulesAndRegex?.cellPhone?.blockComposing
                                  }
                                  onBlur={() => {
                                    cleanInput('phone',
                                      rulesParams?.cellPhone?.cleanRegex
                                      ?? RulesAndRegex?.cellPhone?.cleanRegex);
                                  }}
                                  className={classes.styleInputs}
                                />
                              </Grid>
                            </Grid>
                          </CardContent>
                        </OwnCard>
                        <Box sx={{ mt: 2 }} />
                        <Grid item sx={12} md={12}>
                          <OwnCard>
                            <CardContent style={{ width: '100%' }}>
                              <Grid container spacing={2} style={{ width: '100%' }}>
                                <Grid item xs={12} md={12}>
                                  <OwnTypography style={{ marginBottom: '8px' }}>
                                    Datos de ubicación
                                    {' '}
                                    {whatchPersonType !== 'J' && '(Opcional)'}
                                  </OwnTypography>
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography style={{
                                      color: theme.body.cart.products.text, fontSize: '1rem', fontWeight: 400, marginRight: '12px', fontFamily: '"Karla"', letterSpacing: 0,
                                    }}
                                    >
                                      Mis datos de ubicación son diferentes a
                                      {' '}
                                      {nameCountry()}
                                    </Typography>
                                    <FormControlLabel
                                      style={{
                                        margin: 0,
                                      }}
                                      control={(
                                        <Switch
                                          checked={useLocationData}
                                          onChange={(e) => handleToggleLocation(e.target.checked)}
                                          // disabled={currentItem?.billing?.personType === 'J'}
                                          classes={{
                                            switchBase: classes.switchBase,
                                            checked: classes.checked,
                                            disabled: classes.disabled,
                                            track: classes.track,
                                          }}
                                        />
                                      )}
                                      label=""
                                    />
                                  </div>
                                </Grid>
                                {useLocationData ? (
                                  <>
                                    <Grid item xs={12} md={4}>
                                      <OwnCustomSelectAutocomplete
                                        label="País"
                                        name="countryid"
                                        options={countriesList || []}
                                        control={control}
                                        error={errors}
                                        iconExpandMore={ExpandMoreIcon}
                                        styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                        className={classes.customSelectFont}
                                        inputProps={{
                                          MenuProps: { classes: { paper: classes.menuFont } },
                                        }}
                                        rule={whatchPersonType === 'J' ? Rules.required : {}}
                                        required={whatchPersonType === 'J'}
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                      <OwnCustomInput
                                        label="Ubicación"
                                        name="externalLocation"
                                        control={control}
                                        error={errors}
                                        styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                        className={classes.customSelectFont}
                                        required={!!getValues('countryid') || whatchPersonType === 'J'}
                                        InputPropsParam={{
                                          endAdornment: (
                                            <Tooltip
                                              title={(
                                                <div style={{
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  fontFamily: '"Raleway"',
                                                  fontSize: '12px',
                                                  letterSpacing: 0,
                                                  lineHeight: '16px',
                                                }}
                                                >
                                                  <div>Ingrese la región y la localidad según</div>
                                                  <div>la organización territorial de su país.</div>
                                                  <div>Ejemplo:</div>
                                                  <div>Colombia (Antioquia - Medellín)</div>
                                                  <div>Ecuador (Pichincha - Quito)</div>
                                                </div>
                                              )}
                                              arrow
                                              placement="bottom"
                                              classes={{
                                                tooltip: classes.myCustomTooltip,
                                              }}
                                            >
                                              <IconButton size="small" disableRipple style={{ padding: '4px', cursor: 'default', backgroundColor: 'transparent' }}>
                                                <InfoOutlinedIcon fontSize="small" style={{ color: theme.body.form.infoOutlinedIcon }} />
                                              </IconButton>
                                            </Tooltip>
                                          ),
                                        }}
                                        inputProps={{
                                          maxLength: rulesParams?.externalLocation?.rules.maxLength.value
                                          ?? 100,
                                        }}
                                        rule={{
                                          ...((!!getValues('countryid') || whatchPersonType === 'J') ? Rules.required : {}),
                                          ...rulesParams?.externalLocation?.rules,
                                        }}
                                        cleanInputPattern={
                                          rulesParams?.externalLocation?.cleanRegex
                                          ?? RulesAndRegex?.externalLocation?.cleanRegex
                                        }
                                        blockComposing={
                                          rulesParams?.externalLocation?.blockComposing
                                          ?? RulesAndRegex?.externalLocation?.blockComposing
                                        }
                                        onBlur={() => {
                                          cleanInput('externalLocation',
                                          rulesParams?.externalLocation?.cleanRegex
                                          ?? RulesAndRegex?.companfullAddresyName?.cleanRegex);
                                        }}
                                      />
                                    </Grid>
                                  </>
                                ) : (
                                  <>
                                    <Grid item xs={12} md={6}>
                                      <OwnCustomSelect
                                        label={parameterApp?.labels?.labelRegion || 'Departamento'}
                                        name="departmentid"
                                        options={departaments}
                                        control={control}
                                        error={errors}
                                        iconExpandMore={ExpandMoreIcon}
                                        styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                        className={classes.customSelectFont}
                                        inputProps={{
                                          MenuProps: { classes: { paper: classes.menuFont } },
                                        }}
                                        rule={whatchPersonType === 'J' ? Rules.required : {}}
                                        required={whatchPersonType === 'J'}
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <OwnCustomSelect
                                        label={parameterApp?.labels?.labelCity || 'Cuidad/Municipio'}
                                        name="cityid"
                                        options={cities}
                                        control={control}
                                        error={errors}
                                        iconExpandMore={ExpandMoreIcon}
                                        required={!!getValues('departmentid') || whatchPersonType === 'J'}
                                        rule={(getValues('departmentid') || whatchPersonType === 'J') ? Rules.required : {}}
                                        styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                        className={classes.customSelectFont}
                                        inputProps={{
                                          MenuProps: { classes: { paper: classes.menuFont } },
                                        }}
                                      />
                                    </Grid>
                                  </>
                                )}
                                <Grid item xs={12} md={12}>
                                  <OwnCustomInput
                                    label="Dirección completa"
                                    name="fulladdress"
                                    control={control}
                                    inputProps={{
                                      maxLength: rulesParams?.fullAddres?.rules.maxLength.value
                                          ?? 100,
                                    }}
                                    rule={{
                                      ...rulesParams?.fullAddres?.rules,
                                      required: whatchPersonType === 'J' ? 'Campo obligatorio' : false,
                                    }}
                                    cleanInputPattern={
                                        rulesParams?.fullAddres?.cleanRegex
                                        ?? RulesAndRegex?.fullAddres?.cleanRegex
                                      }
                                    blockComposing={
                                        rulesParams?.fullAddres?.blockComposing
                                        ?? RulesAndRegex?.fullAddres?.blockComposing
                                      }
                                    onBlur={() => {
                                      cleanInput('fulladdress',
                                          rulesParams?.fullAddres?.cleanRegex
                                          ?? RulesAndRegex?.companfullAddresyName?.cleanRegex);
                                    }}
                                    required={whatchPersonType === 'J'}
                                    error={errors}
                                    styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                    className={classes.customSelectFont}
                                  />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                  <OwnCustomInput
                                    label="Código postal"
                                    name="postalCode"
                                    control={control}
                                    error={errors}
                                    styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                                    className={classes.customSelectFont}
                                    inputProps={{
                                      maxLength: rulesParams?.postalCode?.rules.maxLength.value
                                      ?? 100,
                                    }}
                                    rule={{
                                      ...rulesParams?.postalCode?.rules,
                                    }}
                                    cleanInputPattern={
                                      rulesParams?.postalCode?.cleanRegex
                                      ?? RulesAndRegex?.postalCode?.cleanRegex
                                    }
                                    blockComposing={
                                      rulesParams?.postalCode?.blockComposing
                                      ?? RulesAndRegex?.postalCode?.blockComposing
                                    }
                                    onBlur={() => {
                                      cleanInput('postalCode',
                                        rulesParams?.postalCode?.cleanRegex
                                        ?? RulesAndRegex?.companfullAddresyName?.cleanRegex);
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </CardContent>
                          </OwnCard>
                        </Grid>
                        <Box sx={{ mt: 2 }} />
                        <Grid item sx={12} md={12}>
                          <OwnCardTyC>
                            <CardContent style={{ width: '100%' }}>
                              <Grid container spacing={2} style={{ width: '100%' }}>
                                <Grid item md={12}>
                                  <FormControl error={Boolean(errors.terminos)} component="fieldset">
                                    <FormControlLabel
                                      style={{ marginTop: '5px' }}
                                      control={(
                                        <Controller
                                          name="terminos"
                                          control={control}
                                          rules={{ required: true }}
                                          defaultValue={false}
                                          render={({ onChange, onBlur, value }) => (
                                            <OwnCheckbox
                                              size="small"
                                              onBlur={onBlur}
                                              onChange={(e) => onChange(e.target.checked)}
                                              checked={!!value}
                                              style={{
                                                color: getColorForCheckBox(value),
                                                '&:hover': {
                                                  backgroundColor: theme.palette.primary.main,
                                                  color: 'red',
                                                },
                                              }}
                                            />
                                          )}
                                        />
                                      )}
                                      label={(
                                        <Typography
                                          variant="body2"
                                          style={{
                                            fontSize: 16,
                                            fontWeight: 500,
                                            letterSpacing: 0,
                                            fontFamily: '"Raleway"',
                                          }}
                                        >
                                          Acepto
                                          {' '}
                                          <Link
                                            href={cartData?.urlTyC || '#'}
                                            underline="always"
                                            style={{
                                              color: theme.palette.primary.main,
                                              letterSpacing: 0,
                                              fontFamily: '"Raleway"',
                                            }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            Términos y condiciones
                                          </Link>
                                          <span style={{ fontFamily: '"Raleway"', letterSpacing: 0 }}>
                                            {' y '}
                                          </span>
                                          <Link
                                            href={cartData?.urlATDP || '#'}
                                            underline="always"
                                            style={{
                                              color: theme.palette.primary.main,
                                              letterSpacing: 0,
                                              fontFamily: '"Raleway"',
                                            }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            Autorización para el Tratamiento de Datos Personales
                                          </Link>
                                        </Typography>
                                      )}
                                    />
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </OwnCardTyC>
                        </Grid>
                      </Grid>
                      <PurchaseSummary
                        totalProductos={totalProductos}
                        totalNeto={totalNeto}
                        handleNext={handleSubmit(handleNext)}
                        currencySymbol={currencySymbol}
                        activeStep={activeStep}
                        totalIva={totalIvaAjustado}
                        totalRetenciones={totalRetencionesAjustado}
                        granTotal={granTotal}
                        errors={errors}
                        currency={currency}
                        items={items}
                        cartData={cartData}
                        code={code}
                        loadingViewMore={loadingViewMore}
                        setLoadingViewMore={setLoadingViewMore}
                        saveOrderMarketError={saveOrderMarketError}
                        appliedStrings={appliedStrings}
                        valorDescuento={valorDescuento}
                        loadingValidatePromoCode={loadingValidatePromoCode}
                        promoFeedback={promoFeedback}
                        rulesPromoCode={rulesParams.promotionalCode}
                        percentageIva={percentageValueIva()}
                        tieneRetenciones={tieneRetenciones}
                      />
                    </Grid>
                  </>
                )}
                {activeStep === 2 && (
                  <Container maxWidth="lg">
                    <Grid container spacing={4}>
                      <Grid item xs={12} md={8}>
                        <Box display="flex" flexDirection="column">
                          <Box
                            style={{
                              backgroundColor: theme.body.form.backgroud,
                              borderRadius: '16px',
                              padding: '24px',
                              border: `1px solid ${theme.body.cart.products.secondary}`,
                              marginBottom: '32px',
                            }}
                          >
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                              <Typography style={{
                                fontWeight: 700, color: theme.body.form.titleColor, fontSize: '20px', letterSpacing: 0, fontFamily: '"Karla"',
                              }}
                              >
                                Información de facturación
                              </Typography>
                              <IconButton size="small" disabled={licenseLoadingSaveOrder} style={{ color: theme.palette.primary.main }} onClick={() => setActiveStep(1)}>
                                <EditIcon style={{ fontSize: '1.2rem' }} />
                              </IconButton>
                            </Box>

                            <Box display="flex" flexDirection="column" gap="4px" style={{ paddingLeft: '4px' }}>
                              <Tooltip
                                title={whatchPersonType === 'J' ? `${facturationData?.legalName}` : `${facturationData?.firstName} ${facturationData?.lastName}`}
                                arrow
                                placement="top"
                              >
                                <Typography style={{
                                  fontWeight: 600, color: theme.body.cart.products.text, fontSize: '16px', letterSpacing: 0, fontFamily: '"Raleway"', display: 'inline-block', maxWidth: 'fit-content', textOverflow: 'ellipsis', overflow: 'hidden',
                                }}
                                >
                                  {whatchPersonType === 'J' ? `${facturationData?.legalName}` : `${facturationData?.firstName} ${facturationData?.lastName}`}
                                </Typography>
                              </Tooltip>
                              <Typography style={{
                                color: theme.body.cart.products.text, fontSize: '16px', letterSpacing: 0, fontFamily: '"Raleway"',
                              }}
                              >
                                {`${getDocumentTypeCode(facturationData?.documentTypeId)}: ${facturationData?.documentNumber}`}
                              </Typography>
                              <Tooltip
                                title={`${facturationData?.email}`}
                                arrow
                                placement="top-start"
                              >
                                <Typography style={{
                                  color: theme.body.cart.products.text,
                                  fontSize: '16px',
                                  letterSpacing: 0,
                                  fontFamily: '"Raleway"',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                                >
                                  {`${facturationData?.email}`}
                                </Typography>
                              </Tooltip>
                              <Typography style={{
                                color: theme.body.cart.products.text, fontSize: '16px', marginBottom: '16px', letterSpacing: 0, fontFamily: '"Raleway"',
                              }}
                              >
                                {`Número móvil: ${currentCountry?.label?.replace(/\s+/g, '')} ${facturationData?.phone}`}
                              </Typography>
                              {
                                (facturationData?.departmentid && facturationData?.cityid) && (
                                  <>
                                    <Typography style={{
                                      fontWeight: 600, color: theme.body.cart.products.text, fontSize: '16px', letterSpacing: 0, fontFamily: '"Raleway"',
                                    }}
                                    >
                                      {`${getDepartmentName(facturationData?.departmentid)} - ${getCityName(facturationData?.cityid)}`}
                                    </Typography>
                                  </>
                                )
                              }
                              {
                                (facturationData?.countryid && facturationData?.externalLocation) && (
                                  <>
                                    <Typography style={{
                                      fontWeight: 600, color: theme.body.cart.products.text, fontSize: '16px', letterSpacing: 0, fontFamily: '"Raleway"',
                                    }}
                                    >
                                      {countriesList?.find((c) => c.value === facturationData?.countryid)?.label || facturationData?.countryid}
                                      {' '}
                                      -
                                      {facturationData?.externalLocation}
                                    </Typography>
                                  </>
                                )
                              }
                              <Tooltip
                                title={`${facturationData?.fulladdress}`}
                                arrow
                                placement="top-start"
                              >
                                <Typography style={{
                                  color: theme.body.cart.products.text,
                                  fontSize: '16px',
                                  letterSpacing: 0,
                                  fontFamily: '"Raleway"',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                                >
                                  {`${facturationData?.fulladdress}`}
                                </Typography>
                              </Tooltip>
                              <Tooltip
                                title={`${facturationData?.postalCode}`}
                                arrow
                                placement="top-start"
                              >
                                <Typography style={{
                                  color: theme.body.cart.products.text,
                                  fontSize: '16px',
                                  letterSpacing: 0,
                                  fontFamily: '"Raleway"',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                                >
                                  {`${facturationData?.postalCode}`}
                                </Typography>
                              </Tooltip>
                            </Box>
                          </Box>
                          <Box
                            style={{
                              backgroundColor: theme.body.form.backgroud,
                              borderRadius: '16px',
                              padding: '24px',
                              border: `1px solid ${theme.body.form.border}`,
                            }}
                          >
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                              <Typography style={{
                                fontWeight: 700, color: theme.body.form.titleColor, fontSize: '20px', letterSpacing: 0, fontFamily: '"Karla"',
                              }}
                              >
                                Tus productos
                              </Typography>
                              <IconButton size="small" disabled={licenseLoadingSaveOrder} style={{ color: theme.palette.primary.main }} onClick={() => setActiveStep(0)}>
                                <EditIcon style={{ fontSize: '1.2rem' }} />
                              </IconButton>
                            </Box>

                            {items.map((item, index) => (
                              <Box key={index}>
                                <Box display="flex" alignItems="flex-start" style={{ padding: '10px 0' }}>
                                  <img
                                    src={item?.imagePackageUrl || iconoProducto}
                                    alt="Producto"
                                    style={{
                                      marginRight: '12px',
                                      objectFit: 'contain',
                                      width: '24px',
                                    }}
                                  />
                                  <Box display="flex" flexDirection="column">
                                    <Typography style={{
                                      fontWeight: 600, color: theme.body.cart.products.text, fontSize: '16px', lineHeight: '1.2rem', letterSpacing: 0, fontFamily: '"Raleway"',
                                    }}
                                    >
                                      {item.packageDescription}
                                    </Typography>
                                    <Typography
                                      style={{
                                        color: theme.body.cart.products.text,
                                        fontSize: '16px',
                                        marginTop: '4px',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        letterSpacing: 0,
                                        fontFamily: '"Raleway"',
                                      }}
                                    >
                                      <span style={{ marginRight: '20px' }}>
                                        Vigencia:
                                        {' '}
                                        {item.validityTypeId === 'I'
                                          ? 'Ilimitada'
                                          : `${item.validityPeriod} ${getValidityLabel(item.validityTypeId, item.validityPeriod)}`}
                                      </span>

                                      <span style={{ marginRight: '20px' }}>
                                        Formato:
                                        {' '}
                                        {getDeviceLabel(item.deviceTypeCode)}
                                      </span>

                                      <span>
                                        Cantidad:
                                        {' '}
                                        {item.quantity}
                                      </span>
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      </Grid>
                      <PurchaseSummary
                        totalProductos={totalProductos}
                        totalNeto={totalNeto}
                        handleNext={handleNext}
                        currencySymbol={currencySymbol}
                        activeStep={activeStep}
                        totalIva={totalIvaAjustado}
                        totalRetenciones={totalRetencionesAjustado}
                        granTotal={granTotal}
                        licenseLoadingSaveOrder={licenseLoadingSaveOrder}
                        currency={currency}
                        items={items}
                        cartData={cartData}
                        code={code}
                        loadingViewMore={loadingViewMore}
                        setLoadingViewMore={setLoadingViewMore}
                        saveOrderMarketError={saveOrderMarketError}
                        appliedStrings={appliedStrings}
                        valorDescuento={valorDescuento}
                        loadingValidatePromoCode={loadingValidatePromoCode}
                        promoFeedback={promoFeedback}
                        rulesPromoCode={rulesParams.promotionalCode}
                        percentageIva={percentageValueIva()}
                        tieneRetenciones={tieneRetenciones}
                      />
                    </Grid>
                  </Container>
                )}
              </Box>
            </Container>
            <CustomDialog
              isOpen={openEditDialog}
              setIsOpen={setOpenEditDialog}
              textTitle={selectedItem?.packageDescription}
              textAccept="Aceptar"
              textCloseDialog="Cancelar"
              acceptAction={handleSaveEdit}
              showIcon={false}
              maxWidthValue="608px"
              acceptButtonWeight={500}
              cancelButtonWeight={500}
              acceptButtonStyle={{
                backgroundColor: theme.palette.primary.main,
                fontSize: '16px',
                letterSpacing: 0,
                fontFamily: '"Karla"',
              }}
              cancelButtonStyle={{
                backgroundColor: theme.palette.primary.contrastText,
                border: `1px solid ${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                fontSize: '16px',
                letterSpacing: 0,
                fontFamily: '"Karla"',
              }}
              alignLeft
            >
              <Box sx={{ width: '100%', textAlign: 'left' }}>
                <Typography
                  style={{
                    fontSize: '16px',
                    fontWeight: 600,
                    color: theme.body.form.titleColor,
                    marginBottom: '20px',
                    textAlign: 'left',
                    letterSpacing: 0,
                    fontFamily: '"Raleway"',
                    marginTop: '15px',
                  }}
                >
                  Personaliza tu certificado
                </Typography>

                <Grid container>
                  <Grid item container xs={12} sx={{ mb: 1 }}>
                    <Grid item xs={6}>
                      <Typography
                        style={{
                          fontWeight: 500,
                          color: theme.body.form.titleColor,
                          fontSize: '16px',
                          textAlign: 'left',
                          letterSpacing: 0,
                          fontFamily: '"Raleway"',
                        }}
                      >
                        Formato
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        style={{
                          fontWeight: 500,
                          color: theme.body.form.titleColor,
                          fontSize: '16px',
                          textAlign: 'left',
                          letterSpacing: 0,
                          fontFamily: '"Raleway"',
                        }}
                      >
                        Vigencia
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid item container xs={12}>
                    <Grid item xs={6}>
                      <RadioGroup
                        row
                        value={selectedItem?.deviceTypeCode}
                        onChange={(e) => handleDeviceChange(e.target.value)}
                      >
                        {availableDevices.map((devCode) => (
                          <FormControlLabel
                            key={devCode}
                            value={devCode}
                            control={<Radio size="small" className={classes.radio} />}
                            label={<Typography sx={{ fontSize: '16px' }} style={{ letterSpacing: 0, fontFamily: '"Raleway"' }}>{getDeviceLabel(devCode)}</Typography>}
                          />
                        ))}
                      </RadioGroup>
                    </Grid>

                    <Grid item xs={6}>
                      <RadioGroup
                        row
                        value={selectedItem?.validityPeriod?.toString()}
                        onChange={(e) => handleValidityChange(e.target.value)}
                        sx={{ flexWrap: 'nowrap' }}
                      >
                        {availableVigencias.map((priceOption) => (
                          <FormControlLabel
                            key={priceOption.validityPeriod}
                            value={priceOption.validityPeriod.toString()}
                            control={<Radio size="small" className={classes.radio} />}
                            label={(
                              <Typography
                                sx={{
                                  fontSize: '16px', ml: -0.5,
                                }}
                                style={{ letterSpacing: 0, fontFamily: '"Raleway"' }}
                              >
                                {priceOption.validityPeriod}
                                {' '}
                                {getValidityLabel(
                                  selectedItem?.validityTypeId,
                                  priceOption.validityPeriod,
                                )}
                              </Typography>
                            )}
                            sx={{ mr: 1, ml: 0 }}
                          />
                        ))}
                      </RadioGroup>
                    </Grid>
                  </Grid>
                  <Grid item container xs={12} sx={{ mt: 6, pt: 2, borderTop: `1px solid ${theme.palette.divider}` }} style={{ marginTop: '22px' }}>
                    <Grid item xs={12} sx={{ mb: 2 }}>
                      <Typography
                        sx={{
                          color: theme.body.form.titleColor, fontSize: '16px',
                        }}
                        style={{ letterSpacing: 0, fontFamily: '"Raleway"' }}
                      >
                        Valor unitario:
                        <span style={{ letterSpacing: 0, fontFamily: '"Karla"' }}>
                          {` ${currencySymbol} ${formatMoney(selectedItem?.priceUnit).toLocaleString()} ${currency}`}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: '14px', marginBottom: '16px' }}>
                      <Typography
                        style={{
                          color: theme.body.cart.products.text,
                          display: 'block',
                          fontWeight: 500,
                          fontSize: '16px',
                          letterSpacing: 0,
                          fontFamily: '"Raleway"',
                        }}
                      >
                        Subtotal
                        {' '}
                        <span style={{ fontFamily: '"Karla"', fontWeight: 400 }}>
                          {`(${selectedItem?.quantity} ${selectedItem?.quantity > 1 ? 'unidades' : 'unidad'})`}
                        </span>
                      </Typography>
                      <Box
                        style={{
                          display: 'flex',
                          justifyContent: 'start',
                          gap: '4px',
                        }}
                      >
                        <OwnTypographySubtotal
                          style={{
                            fontWeight: 700,
                            letterSpacing: 0,
                            fontFamily: '"Karla"',
                          }}
                        >
                          {`${currencySymbol} ${(formatMoney(selectedItem?.priceUnit * selectedItem?.quantity).toLocaleString())}`}
                        </OwnTypographySubtotal>

                        <OwnTypographySubtotal
                          style={{
                            fontWeight: 400,
                            letterSpacing: 0,
                            fontFamily: '"Karla"',
                          }}
                        >
                          {`${currency}`}
                        </OwnTypographySubtotal>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </CustomDialog>
          </>
        )}
    </>
  );
};

const mapStateToProps = (props) => ({
  cartData: props.license.cartData,
  statesAndCities: props.general.statesAndCities,
  documentTypes: props.general.documentTypes,
  parameterApp: props.general.parameterApp,
  licenseLoadingSaveOrder: props.license.licenseLoadingSaveOrder,
  getItemsCatalog: props.license.getItemsCatalog,
  loadingMarketPlace: props.license.loadingMarketPlace,
  getParametersMarket: props.general.getParametersMarket,
  licenseSaveOrderSuccess: props.license.licenseSaveOrderSuccess,
  saveOrderSuccess: props.license.saveOrderSuccess,
  saveOrderMarketError: props.license.saveOrderMarketError,
  loadingValidatePromoCode: props.license.loadingValidatePromoCode,
  promoFeedback: props.license.promoFeedback,
  emailsInBalckList: props.emails.emailsBlackList,
  loadingContractCustomerInfo: props.license.loadingContractCustomerInfo,
  getContractCustomerInfo: props.license.getContractCustomerInfo,
  countriesFlags: props.license.countriesFlags,
});

const mapDispatchToProps = {
  updateCartQuantity: updateCartQuantityAction,
  removeCartItem: removeCartItemAction,
  getStatesAndCities: getStateAndCitiesAction,
  getDocumentTypes: getDocumentTypesAction,
  getParmeterConfig: getParmeterConfigAction,
  saveOrder: saveOrderAction,
  getCatalog: getCatalogAction,
  updateCartItem: updateCartItemAction,
  cartAdd: cartAddAction,
  cartAddEmergency: cartAddEmergencyAction,
  sendToePaycoPaymentMarket: sendToePaycoPaymentMarketAction,
  getBlackListEmails: getBlackListEmailsAction,
  getContractCustomerInfoFunction: getContractCustomerInfoAction,
  getCountriesFlags: GetCountriesFlagsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketPlace);
